import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SurveyTemplateStatus } from '@/models'

export type { SurveyTemplateStatus }

interface GetSurveyTemplatesStatusRequest {
  buildingId?: number
}

const USE_GET_SURVEY_TEMPLATES_STATUS_QUERY_KEY = 'useGetSurveyTemplatesStatus'

export const getSurveyTemplatesStatusQueryKey = (data: GetSurveyTemplatesStatusRequest) => [
  USE_GET_SURVEY_TEMPLATES_STATUS_QUERY_KEY,
  data,
]

export const getSurveyTemplatesStatus = async (
  data: GetSurveyTemplatesStatusRequest,
): Promise<SurveyTemplateStatus[]> => {
  const response = await authAPI.get('/survey-templates/status', { params: data })
  return response.data
}

export const useGetSurveyTemplatesStatus = (data: GetSurveyTemplatesStatusRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: () => getSurveyTemplatesStatus(data),
    queryKey: getSurveyTemplatesStatusQueryKey(data),
  })
}
